import React, { useState } from 'react';
import axios from "axios";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Container,
  Input,
  FormGroup,
} from "reactstrap";
import { Redirect, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import './signUpSuccessfull.css';

const passwordRegex = /^(?=.*?[A-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;

const VerifyAccount = () => {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const token = location.pathname.split('/verify/')[1]?.slice(0, -1);

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required.')
      .min(10, 'Password must be at least 10 characters.')
      .matches(
        passwordRegex,
        'Password must contain at least one uppercase letter and one special character.'
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match.')
      .required('Please confirm your password.')
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setErrorMsg('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL_BASE}users/activate-account/`, {
        password: values.password,
        token: token
      });
      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => setRedirect(true), 3000);
      } else {
        setErrorMsg(response.data.status || 'An unexpected error occurred.');
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.status || 'An error occurred. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (redirect) {
    return <Redirect to="/authentication/login" />;
  }

  return (
    <Container className="bl-back-image" fluid style={{
      height: "100vh", display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: '600px',
          padding: '20px',
          margin: 'auto',
          borderRadius: '8px',
          boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)'
        }}
      >
        <CardBody>
          <CardTitle tag="h1" style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center' }}>
            Just One More Step...
          </CardTitle>
          <CardText>
            <p style={{ fontSize: '16px', paddingLeft: '12px', marginTop: '24px' }}>
              Please set your password to confirm your account.
              <br /><br />
              <strong>Password must:</strong>
              <br />
              <ul style={{ textAlign: 'left', fontSize: '14px', marginTop: '8px' }}>
                <li>Be at least 10 characters long</li>
                <li>Contain at least one uppercase letter</li>
                <li>Include at least one special character (e.g., @, #, $, %)</li>
              </ul>
            </p>

            <Formik
              initialValues={{ password: '', confirmPassword: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="p-2" style={{ fontSize: '16px' }}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="password"
                      name="password"
                      id="passwordNew"
                      placeholder="Password"
                    />
                    <ErrorMessage name="password" component="div" className="text-danger mt-1" style={{ fontSize: '12px' }} />
                  </FormGroup>

                  <FormGroup className="mt-2">
                    <Field
                      as={Input}
                      type="password"
                      name="confirmPassword"
                      id="passwordConfirm"
                      placeholder="Confirm password"
                    />
                    <ErrorMessage name="confirmPassword" component="div" className="text-danger mt-1" style={{ fontSize: '12px' }} />
                  </FormGroup>

                  {errorMsg && (
                    <Alert color="danger">{errorMsg}</Alert>
                  )}

                  <Button
                    className="btn btn-lg btn-block btn-ml"
                    type="submit"
                    disabled={isSubmitting}
                    style={{ fontSize: '16px', marginTop: '20px' }}
                  >
                    {isSubmitting ? 'Confirming...' : 'Confirm Your Account'}
                  </Button>
                </Form>
              )}
            </Formik>
          </CardText>

          {success && (
            <Alert color="success" style={{ margin: '20px' }}>
              Your account has been activated! Redirecting to login page...
            </Alert>
          )}
        </CardBody>
      </Card>
    </Container>
  );
};

export default VerifyAccount;